var lx = lx || {};
/*
* lx.dialog.open({id:"nekiHtmlId", maxWidth: "600px", title: "neki title", html: "<div>sadrzaj dialoga</div>"});
*/
lx.dialog = {
    dialogs: [],
    getDialogIdx: function (pId){
        if (pId) {
            for (var i = 0; i < this.dialogs.length; i++) {
                if (this.dialogs[i].id && this.dialogs[i].id == pId) {
                    return i;
                }
            }
        }
        return null;
    },
    /* type: warning, info, danger, success */
    alertMsg: (pData) => {
        return '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--'+ (pData.type ? pData.type : 'warning') +' t-Alert--removeHeading"'
               		+ 'style="'+(pData.type == 'warning' ? 'border: 1px solid #FEF7E0;background-color: #FEF7E0;' : '')+'margin-bottom:0rem;">'+
                    '<div class="t-Alert-wrap" style="display: block;text-align: center;">'+
                        '<div class="t-Alert-icon" style="padding: 3.2rem 3.2rem 1.6rem 3.2rem;"><span class="t-Icon " style="'+ (pData.type == 'warning' ? 'color: #FFC628; ' : '')+ 'font-size: 4.8rem;width: 4.8rem;height: 4.8rem;"></span></div>'+
                        '<div class="t-Alert-content" style="width:100%;padding:1.6rem 3.2rem 3.2rem 3.2rem;"><div class="t-Alert-body">'+ pData.msg +'</div></div>'+
                    '</div>'+
                '</div>'
    },
    open: function (pOpt) {
        var html = '';
        var dialogIdx = this.getDialogIdx(pOpt.id)
        var dialogOpened = (dialogIdx != null);
        /*if (pOpt.id) {
            for (var i = 0; i < this.dialogs.length; i++) {
                if (this.dialogs[i].id && this.dialogs[i].id == pOpt.id) {
                    dialogIdx = i;
                    dialogOpened = true;
                    break;
                }
            }
        }*/
        if (!dialogOpened) {
            dialogIdx = this.dialogs.length;
            this.dialogs.push(pOpt);
        }
        html = '<div dialogid="' + dialogIdx + '" class="lxpDialog" id="lxpDialog_'+ pOpt.id +'">'
            + '<div class="lxpDialog__content"' + (pOpt.maxWidth ? ' style="max-width:' + pOpt.maxWidth + '"' : '') + '>'
            + '<div class="lxpDialog__header"><span class="lxpDialog__close" onclick="lxpDialog.close(this);"><i class="far fawe-times" style="position: absolute;top: 16px;right:20px;font-size:1.2rem;"></i></span>'
            + '<h3>' + (pOpt.title ? pOpt.title : '') + '</h3></div>'
            + '<div class="lxpDialog__body">' + 
            (pOpt.alertMsg ? lx.dialog.alertMsg(pOpt.alertMsg) : '') +
            (pOpt.container ? '<div class="t-Region t-Region--removeHeader t-Region--scrollBody t-Form--stretchInputs">'+
                                '<div class="t-Region-bodyWrap">'+
                                    '<div class="t-Region-body">'+
                                        '<div class="container">'+ pOpt.html +'</div>'+
                                    '</div>'+
                                '</div>'+
                              '</div>' 
                            : pOpt.html)
            + '</div>';
        if (pOpt.buttons) {
            html += '<div class="footer">';
            html +=  lx.btn.genAll( pOpt.buttons );
            html += '</div>';
        }
        html +='</div>'
             + '</div>';
        if (dialogOpened) {
            $(".lxpDialog[dialogid=" + dialogIdx + "]").replaceWith(html);
        } else {
            $("body").append(html);
            window.onclick = function (event) {
                var element = $(event.target);
                if (element.hasClass('lxpDialog')) {
                    lx.dialog.close(element);
                }
            }
        }
    },
    close: function (pThis, pDialogId) {
        self = lx.dialog;
        var dialogIdx = (pDialogId ? self.getDialogIdx(pDialogId) : $(pThis).closest(".lxpDialog").attr("dialogid") );
		console.log('dialogIdx='+dialogIdx);
        var dialog = self.dialogs[dialogIdx];
        if (dialog.close) dialog.close();
        $(".lxpDialog[dialogid=" + dialogIdx + "]").remove();
        self.dialogs.splice(dialogIdx, 1);
    }
};

lx.dialog.confirm = function (par) {
    var confirmDiv;
    var confirmDialog1;
    confirmDiv = "<div class='connectionConfirm'><div class='connectionConfirmTxt'>";
    confirmDiv += "<div class='connectionConfirmWarn'>" + apex.lang.getMessage(par.warn) + "</div>";
    confirmDiv += apex.lang.getMessage(par.txt) + "</div><div class='connectionConfirmBtns'><a href='#' role='button'></a>" +
        "<a id='lxConnDialogYes' href='javascript:void(0);' class='m-btn gray mini' role='button'><span>" +
        lx.tran.get('YES') + "</span></a>" +
        "<a id='lxConnDialogCancel' href='javascript:void(0);' class='m-btn blue mini' role='button'><span>" +
        lx.tran.get('JS24') + "</span></a>";
    confirmDialog1 = $(confirmDiv).dialog({
        resizable: false,
        width: 350,
        modal: true,
        close: function (event, ui) {
            $("#lxConnDialogYes").unbind();
            $("#lxConnDialogCancel").unbind();
            $(confirmDialog1).dialog("destroy");
        }
    });
    $("#lxConnDialogYes").click(function () {
        if (par.btn) {
            apex.submit(par.btn);
        } else if (par.action) {
            deleteAction(par.action);
        }
        $(confirmDialog1).dialog("close");
    });
    $("#lxConnDialogCancel").click(function () {
        $(confirmDialog1).dialog("close");
    });

};

lx.native = {
    remove: function() {
        // Remove the dialog
        document.querySelectorAll('.ui-dialog--notification').forEach(dialog => dialog.remove());

        // Remove the overlay
        document.querySelectorAll('.ui-widget-overlay').forEach(overlay => overlay.remove());
    }
};

lx.drawer = {
    open: (pTitle, pHtml) => {
        $('body').append(`<div style="position: fixed; height: auto; width: 960px; top: 0px; left: 194px; max-width: 100%;" tabindex="-1" role="dialog" class="ui-dialog ui-corner-all ui-widget ui-widget-content ui-front ui-dialog--apex t-Drawer-page--standard t-Drawer--pullOutEnd" aria-describedby="apex_dialog_3" aria-labelledby="ui-id-5" aria-modal="true">
    <div class="ui-dialog-titlebar ui-corner-all ui-widget-header ui-helper-clearfix">
        <span id="ui-id-5" class="ui-dialog-title"> `+ pTitle +` </span>
        <button type="button" class="ui-button ui-corner-all ui-widget ui-button-icon-only ui-dialog-titlebar-close" title="Close" aria-label="Close" aria-describedby="ui-id-5" onclick="lx.drawer.close(this);">
            <span class="ui-button-icon ui-icon ui-icon-closethick"></span>
        </button>
    </div>
    <div id="apex_dialog_3" class="ui-dialog-content ui-widget-content js-dialogReady" style="width: auto; min-height: 0px; max-height: none; height: 907px;">` +
        pHtml +
    `</div></div>`);
    },
    close: (pThis) => {
        if (pThis) $(pThis).closest(".ui-dialog").remove();
        else $(".t-Drawer").closest(".ui-dialog").remove();
    }
}

/* TODO cleanup after UT */
var lxpDialog = lx.dialog;
var lxConfirm = lx.dialog.confirm;